import React, { useEffect, useState } from "react";
import API from "../Services/AddPackage";
import { toast } from "react-toastify";

const AddOnList = ({ selectedAddOn, setSelectedAddOn, selectedActivityCenter }) => {
    const [addOnList, setAddOnList] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedAddOn(e.target.value);

    };

    const bindAddOn = async () => {
        try {
            const payload = {
                is_active: 1,
                limit:0
            };
            const response = await API.get_Addon(payload);
            setAddOnList(response?.data?.result || []);
            setError(null);
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            } else if (error.response?.status === 404) {
                toast.error("Requested resource not found.");
            } else {
                setError("Failed to fetch Add-ons.");
            }
        }
    };

    useEffect(() => {
        bindAddOn();
    }, []);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="ddlAddOn">
                        Add-On Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                        className="form-select"
                        id="ddlAddOn"
                        value={selectedAddOn || ""}
                        onChange={handleChange}
                        required

                    >
                        <option value="">Select</option>
                        {addOnList.length > 0 ? (
                            addOnList.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name} ({item.Location?.name})
                                </option>
                            ))
                        ) : (
                            <option disabled>No add-ons available</option>
                        )}
                    </select>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
            </div>
        </div>
    );
};

export default AddOnList;
